
/* injects from baggage-loader */

'use strict';

export default class AccountSettingsConnectedAccountsController {

	constructor($log, $timeout, $location, $stateParams, Parse, STRIPE_REDIRECT_URI, STRIPE_CLIENT_ID) {
		'ngInject';

		this.$log = $log;
		this.$timeout = $timeout;
		this.$query = $stateParams;
		this.$location = $location;
		this.Parse = Parse;

		// CONSTANTS
		this.STRIPE_REDIRECT_URI = STRIPE_REDIRECT_URI;
		this.STRIPE_CLIENT_ID = STRIPE_CLIENT_ID;

		this.heading = 'Connected Accounts';

		this.stripe = {
			connected: false,
			state: 'nf-connect-stripe'
		}

	}

	$onInit() {
		// this.$log.log(this.$query);
		this.$log.log(this.integrations);

		let stripe_integration = this.integrations.find(i => i.service_name === 'stripe');
		if (stripe_integration) {
			this.stripe.connected = stripe_integration.connected;
		}

		// Send the query data to the stripe response handler
		if (this.$query.code && this.$query.state) {
			this.handleStripeResponse(this.$query);
		}
	}


	/**
	 * Assemble the URL to connect the users stripe account
	 */
	getStripeConnectURL() {

		let url = 'https://connect.stripe.com/express/oauth/authorize';

		let params = {
			redirect_uri: this.STRIPE_REDIRECT_URI,
			client_id: this.STRIPE_CLIENT_ID,
			state: this.stripe.state
		}

		// Return assembled URL
		return `${url}?${Object.keys(params).reduce((query, key) => [...query, `${key}=${params[key]}`], []).join('&')}`;

	}


	/**
	 * Handle the response from Stripe connect redirect
	 * @param {Object} query 
	 */
	handleStripeResponse(query) {

		// Drop the request if already connected
		if (this.stripe.connected) {
			return false;
		}

		// Verify the state
		if (query.state !== this.stripe.state) {
			// Throw error, bad redirect
			return false;
		}

		// Call the cloud code fn to connect the user
		this.Parse.Cloud.run('connectStripeAccount', query)
			.then(res => {
				this.$log.log(res);
				this.stripe.connected = true;
				this.$timeout();
			})
			.catch(err => {
				this.$log.error(err);
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/account/settings/connected-accounts/account.settings.connected-accounts.controller.js